import React from "react";
import { connect } from "react-redux";
import PageHeaderWrapper from "../../../components/PageHeaderWrapper";
import { Card } from "antd";
import { TableComp } from "sz-react-utils";
import Request, { API_URL, LAPI_URL } from "../../../request";



class StaffDirectory extends React.Component {

    componentDidMount() {
    }


    apiRequest = (params) =>{
        return new Promise(async(resolve)=>{
            params.userBranch = "5eda25ef70fe497aac1e9743";
            params.type = {$ne:'Student'};
            params.active = true;
            params.isAdministrator = false;
            let response = await Request.loadUser({ ...params, regExFilters: ['name', 'email', 'department', 'designation', 'userMobile'] });
            return resolve(response);
        })
    }

    constructor(props) {
        super(props);
        this.table = React.createRef();
    }

    render() {
        const columns = [
            {
                title:"#",
                key:"index",
                width:35,
                render: (text, record, index) => {
                    return index + 1;
                }
            },
            {
                title:'Name',
                key:'name',
                searchTextName:'name',
                filterRegex:true
            },
            {
                title:'Department',
                key:'department',
                searchTextName:'department',
                filterRegex:true
            },
            {
                title:'Designation',
                key:'designation',
                searchTextName:'designation',
                filterRegex:true
            },
            {
                title:'Email',
                key:'email',
                searchTextName:'email',
                filterRegex:true
            },
            {
                title:'Phone',
                key:'userMobile',
                searchTextName:'Phone',
                filterRegex:true,
                render:(text,record)=>(
                    <div>{record.countryCode?`${record.countryCode}-${record.userMobile}`:`+91-${record.userMobile}`}</div>
                )
            }
        ];
        return (
            <PageHeaderWrapper title="Staff Directory">
                <Card bordered={true}>
                    <TableComp
                        ref={this.table}
                        columns={columns}
                        apiRequest={this.apiRequest}
                        extraProps={{ scroll: { x: 900 } }}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 50,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />

                </Card>

            </PageHeaderWrapper>
        )
    }




}









const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StaffDirectory)